import { Component, OnInit, ViewEncapsulation, OnChanges, Input, SimpleChanges } from '@angular/core';
import { I18nService } from 'app/services/i18n/i18n.service';
import { Rest } from '../../../../rest/rest_client';
import { ServerValidatedFormComponent } from '../../../server-validated-form/server-validated-form.component';

@Component({
  selector: 'app-motion-sensor-gl320m',
  templateUrl: './motion-sensor-gl320m.component.html',
  styleUrls: ['./motion-sensor-gl320m.component.css']
})
export class MotionSensorGl320mComponent extends ServerValidatedFormComponent implements OnInit {

  modeOptions: any = [
    { label: "Disable this function", value: "DISABLE" },
    { label: "Get a location fix and then send +RESP:GTMSA with the current position to the backend server and an SMS with a Google Map link to the numbers.", value: "ENABLE" },
  ];

  lastPositionOptions: any = [
    { label: "Disable this feature", value: "DISABLE" },
    { label: "Enable this feature", value: "ENABLE" },
  ];
  
  @Input() msaParameters: Rest.MotionSensorAlarmGL320M;
  
  constructor(protected i18n: I18nService) { super(i18n); }
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges){
    if (changes["deviceParams"]) {
      console.log("arrive deviceParams", this.msaParameters);
    }
  }
}
